import React from 'react';
import { Link } from 'react-router-dom';
import api from '../api/client';

class ProductsPage extends React.Component {
  constructor(props) {
    super(props);
    this.state = { products: [], loading: true, addingId: null };
  }

  componentDidMount() {
    api.getProducts()
      .then((products) => this.setState({ products, loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  handleAddToCart = (productId, licenseType) => {
    this.setState({ addingId: productId + licenseType });
    api.addToCart(productId, licenseType, 1)
      .then(() => {
        this.props.onCartChange && this.props.onCartChange();
      })
      .finally(() => this.setState({ addingId: null }));
  };

  render() {
    const { products, loading, addingId } = this.state;
    if (loading) return <p className="loading">Loading licenses...</p>;

    return (
      <div className="products-page">
        <h1>Software licenses</h1>
        <div className="product-grid">
          {products.map((p) => (
            <div key={p.id} className="product-card">
              <img src={p.image_url} alt={p.name} />
              <h3><Link to={`/products/${p.id}`}>{p.name}</Link></h3>
              <p className="vendor">{p.vendor}</p>
              <p className="desc">{p.description}</p>

              <div className="price-options">
                <div className="price-option">
                  <span>Shared license (pool of {p.shared_pool_size})</span>
                  <strong>₦{Number(p.shared_price).toLocaleString()}</strong>
                  <button
                    className="btn btn-primary"
                    disabled={addingId === p.id + 'shared'}
                    onClick={() => this.handleAddToCart(p.id, 'shared')}
                  >
                    Add shared to cart
                  </button>
                </div>
                <div className="price-option">
                  <span>Private license</span>
                  <strong>₦{Number(p.full_price).toLocaleString()}</strong>
                  <button
                    className="btn"
                    disabled={addingId === p.id + 'private'}
                    onClick={() => this.handleAddToCart(p.id, 'private')}
                  >
                    Add private to cart
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    );
  }
}

export default ProductsPage;
